<template>
  <div>
    <div v-if="loading" class="flex content-center justify-center item-center">
      <MoonLoader class="mt-24"> </MoonLoader>
    </div>
    <div v-else>
      <div v-if="company">
        <CompanyShow :showDeleteCompany="true" />

        <RolesIndex
          :roles="company.data.roles"
          :obj="company.data"
          :obj_name="company.data.name"
          :roles_for_select="roles_for_select"
          @removeRole="removeRole($event)"
          @addRole="addRole($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CompanyShow from '../MyOrganization/CompanyShow';
import DeleteButton from '../../../components/buttons/DeleteButton';
import axiosAuth from '../../../axiosMain';
import RolesIndex from '../roles/RolesIndex';
import MoonLoader from '../../../components/svg/SvgLoaderMoon';
import ModalTemplate from '../../../components/modals/ModalTemplate';
export default {
  name: 'SuperUserCompanyShow',
  components: { ModalTemplate, MoonLoader, RolesIndex, DeleteButton, CompanyShow },
  data: function () {
    return {
      company: null,
      open_delete_modal: false,
      roles_for_select: {},
      loading: true,
    };
  },
  mounted() {
    this.setLoader();
    this.getCompany();
    this.getAllRoles();
  },
  methods: {
    addRole: function (event) {
      axiosAuth
        .patch(
          '/company_roles/' + this.$route.params.id,
          {
            roles: [
              {
                role_id: event.role_id,
              },
            ],
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.company.data.roles = response.data.data;
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('The_new_role_was_assigned'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data,
          });
        });
    },
    removeRole: function (event) {
      axiosAuth
        .post(
          '/company_roles/delete/' + this.$route.params.id,
          {
            roles: [
              {
                role_id: event.data.role_id,
              },
            ],
          },
          {
            headers: {
              Authorization: 'Bearer ' + this.$store.getters.token,
            },
          }
        )
        .then((response) => {
          this.company.data.roles = response.data.data;
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('The_role_was_deleted'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
    getCompany: function () {
      axiosAuth
        .get('/companies/' + this.$route.params.id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.company = response.data;
          this.resetLoader();
        })
        .catch((errors) => {
          this.resetLoader();
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
    getAllRoles: function () {
      axiosAuth
        .get('/roles', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.roles_for_select = response.data.data;
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
    setLoader: function () {
      // this.loader = this.$loading.show({
      //   // Optional parameters
      //   container: this.fullPage ? null : this.$refs.formContainer,
      //   canCancel: true,
      //   onCancel: this.onCancel
      // })
      this.loading = true;
    },
    resetLoader: function () {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
</script>

<style scoped></style>
